(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    ngModule.controller('ProductDesignReviewModalController', ['$scope', '$rootScope', '$uibModalInstance', 'product', 'store', '$uibModal', function($scope, $rootScope, $uibModalInstance, product, store, $uibModal) {

        angular.extend($scope, {

            // vars
            //product: trimOutUnselectedAttributes(product),
            // customerProductPrice: product.basePrice,

            product: product,

            store: store,

            //methods

            init: function() {

                $scope.activeImage = product.featuredImage.productImage;

            },

            rejectButton: false,

            approveProduct: function(){

                $uibModalInstance.close({status: 'approved'});

            },

            rejectProduct: function(){

                $uibModalInstance.close({status:'rejected', rejection_message: $scope.rejection_message});

            },

            resetStuff: function() {
                $uibModalInstance.close({status:'reset'});
            },

            thumbnailSwitch: function(productImage) {

                $scope.activeImage = productImage;

            },

            thumbnailLighbox: function() {

                $uibModal.open({
                    animation: true,
                    windowTemplateUrl: 'directives/externalStore/fullScreenModalWindowTemplate.html',
                    templateUrl:'directives/externalStore/fullScreenImageModal.html',
                    controller: function($scope, $uibModalInstance, activeImage, $timeout) {

                        $scope.activeImage = activeImage;

                        $scope.maxHeight = window.innerHeight - 50;

                        $scope.close = function () {
                            $uibModalInstance.dismiss('cancel');
                        };

                    },
                    size: 'lg',
                    resolve: {
                        activeImage: function() {
                            return $scope.activeImage
                        }
                    }
                });

            },


            cancel: function () {
                $uibModalInstance.dismiss('cancel');
            },

        });

        $scope.init();

    }]);

})();
